import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { CarInfo, CarInfoFeature } from '@sbt-web/network/types';
import styles from './AccordionContent.module.scss';
const AccordionContent = t0 => {
  const $ = _c(5);
  const {
    infocarData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className={styles.disclaimer}>I dati delle schede tecniche sono compilati in base alle informazioni ufficiali fornite dalla <strong>Banca Dati Quattroruote</strong>, basata sul Codice Infocar.</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== infocarData) {
    t2 = infocarData.map(_temp);
    $[1] = infocarData;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className={styles.content}>{t1}{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
const InfocarBaseProperty = t0 => {
  const $ = _c(9);
  const {
    title,
    features
  } = t0;
  if (features.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className={styles["infocar-section-heading"]}><span className="caption semibold">{title}</span></h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== features) {
    t2 = features.map(_temp2);
    $[2] = features;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <dl className={styles["infocar-feature-list"]}>{t2}</dl>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <section className={styles["infocar-section"]}>{t1}{t3}</section>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
const InfocarEquipmentProperty = t0 => {
  const $ = _c(17);
  const {
    title,
    features
  } = t0;
  if (features.length === 0 || !features[0]?.value) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== features[0].value || $[1] !== title) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const equipmentList = formatEquipmentValue(features[0].value);
      if (equipmentList.length === 0) {
        t5 = null;
        break bb0;
      }
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = cn(styles["infocar-section"], styles["infocar-equipment-section"]);
        $[7] = t3;
      } else {
        t3 = $[7];
      }
      if ($[8] !== title) {
        t4 = <h3 className={styles["infocar-section-heading"]}><span className="caption semibold">{title}</span></h3>;
        $[8] = title;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      t1 = styles["infocar-feature-list"];
      t2 = equipmentList.map(_temp3);
    }
    $[0] = features[0].value;
    $[1] = title;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2) {
    t6 = <ul className={t1}>{t2}</ul>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <section className={t3}>{t4}{t6}</section>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};

// --- Helpers
const formatEquipmentValue = (value: string): string[] => value.split(',').map(item => item.trim()).filter(item => item.length > 0);
export { AccordionContent };
function _temp(property) {
  const formattedTitle = property.title.toLowerCase();
  const isEquipment = formattedTitle === "equipaggiamento";
  return isEquipment ? <InfocarEquipmentProperty key={formattedTitle} {...property} /> : <InfocarBaseProperty key={formattedTitle} {...property} />;
}
function _temp2(feature) {
  return <div key={feature.label} className={styles["infocar-feature-list-item"]}><dt className={cn(styles["infocar-feature-element"], styles["infocar-feature-label"])}><p className="caption book">{feature.label}</p></dt><dd className={cn(styles["infocar-feature-element"], styles["infocar-feature-value"])}><p className="caption book">{feature.value}</p></dd></div>;
}
function _temp3(item) {
  return <li key={item.toLowerCase()} className={cn("caption book", styles["infocar-equipment-list-item"])}>{item}</li>;
}